export default "__VITE_ASSET__3826d93a__"